import { useState, useRef } from 'react';
import useClickOutside from './useClickOutside';

const DropdownMenu = ({ children, title, onToggle, outsideClickOnly = true, extraDataComponent }) => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef('menu');

    const closeMenu = () => {
        setOpen(false);
        onToggle(false);
    };
    useClickOutside(wrapperRef, closeMenu);

    return (
        <div
            ref={wrapperRef}
            className="relative"
            onClick={() => {
                if (!outsideClickOnly) {
                    closeMenu();
                }
            }}>
            <div
                className="mb-2"
                onClick={(event) => {
                    event.stopPropagation();
                    setOpen((open) => {
                        onToggle(!open);
                        return !open;
                    });
                }}>
                {title}
            </div>
            <div
                className={`${open ? 'block' : 'hidden'} absolute 
                    right-0
                z-10 bg-white rounded-lg min-w-60 shadow-sf-medium`}>
                <div className="p-2">{children}</div>
                {extraDataComponent && <div className="border-t border-sf-gray-100">{extraDataComponent}</div>}
            </div>
        </div>
    );
};

export default DropdownMenu;
